import { Reducer } from 'redux';

import { SearchsState, SearchsTypes } from './types';

const INITIAL_STATE: SearchsState = {
  selectedItems: [],
  error: false,
  loading: false,
};

const reducer: Reducer<SearchsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // SET SELECTED ITEMS
    case SearchsTypes.SET_SELECTED_ITEMS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedItems: action.payload.selectedItems,
      };

    default:
      return state;
  }
};

export default reducer;
